export const wrapLetters = (word: string) => word.split('').map( (l,i) => <span key={i}>{l}</span>);
